import Nav from '../components/Nav';
import { getAccessLevel } from '../auth/cognito';
import FullAdminDashboard from '../sections/FullAdminDashboard';
import EnterpriseOrgAdminDashboard from '../sections/EnterpriseOrgAdminDashboard';
import PublicOrgAdminDashboard from '../sections/PublicOrgAdminDashboard';

export default function AdminDashboard() {
  const level = getAccessLevel();

  function renderDashboard() {
    if (level === 'superadmin_full')    return <FullAdminDashboard visiblePlatforms="both" />;
    if (level === 'admin_enterprise')   return <FullAdminDashboard visiblePlatforms="enterprise" />;
    if (level === 'superadmin_public')  return <FullAdminDashboard visiblePlatforms="public" />;
    if (level === 'orgadmin_enterprise') return <EnterpriseOrgAdminDashboard />;
    if (level === 'orgadmin_public')    return <PublicOrgAdminDashboard />;
    return (
      <div style={{ textAlign: 'center', padding: 80, color: 'rgba(255,255,255,0.4)', fontFamily: 'system-ui' }}>
        Access level could not be determined. Please sign out and sign in again.
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#0a0a1a,#0d1b3e,#050d1f)', fontFamily: "'Segoe UI',system-ui,sans-serif", color: '#fff' }}>
      <Nav />
      {renderDashboard()}
    </div>
  );
}
